'use client';
import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import { X, ChevronLeft, ChevronRight, ZoomIn } from 'lucide-react';
import { mockImagenesLanding } from '@/lib/mockData';

export default function GaleriaSection() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeIdx, setActiveIdx] = useState(0);
  const imagenes = mockImagenesLanding;

  const openLightbox = (idx: number) => {
    setActiveIdx(idx);
    setLightboxOpen(true);
  };

  const prev = () => setActiveIdx((i) => (i - 1 + imagenes.length) % imagenes.length);
  const next = () => setActiveIdx((i) => (i + 1) % imagenes.length);

  return (
    <section id="galeria" className="py-20 bg-background">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <p className="text-accent text-xs font-semibold tracking-widest uppercase mb-3">
            La Propiedad
          </p>
          <h2 className="font-display text-section-title font-bold text-primary mb-4">
            Espacios diseñados para descansar
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Cada rincón de Bahía Baliz fue pensado para que te desconectes del mundo y te reconectes con lo que importa.
          </p>
        </div>

        {/* Mosaic gallery */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 lg:gap-4">
          {imagenes.map((img, idx) => (
            <div
              key={img.id}
              className={`relative overflow-hidden rounded-xl cursor-pointer group ${
                idx === 0 ? 'col-span-2 md:col-span-2 row-span-2' : ''
              }`}
              style={{ aspectRatio: idx === 0 ? '16/9' : '4/3' }}
              onClick={() => openLightbox(idx)}
            >
              <AppImage
                src={img.url}
                alt={img.alt}
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-105"
                sizes="(max-width: 768px) 50vw, 33vw"
              />
              <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/20 transition-colors duration-300 flex items-center justify-center">
                <ZoomIn
                  size={28}
                  className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightboxOpen && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 fade-in">
          <button
            onClick={() => setLightboxOpen(false)}
            className="absolute top-4 right-4 text-white/70 hover:text-white p-2"
            aria-label="Cerrar galería"
          >
            <X size={28} />
          </button>
          <button
            onClick={prev}
            className="absolute left-4 text-white/70 hover:text-white p-2"
            aria-label="Imagen anterior"
          >
            <ChevronLeft size={36} />
          </button>
          <div className="relative w-full max-w-4xl aspect-video rounded-lg overflow-hidden">
            <AppImage
              src={imagenes[activeIdx].url}
              alt={imagenes[activeIdx].alt}
              fill
              className="object-cover"
              sizes="90vw"
              priority
            />
          </div>
          <button
            onClick={next}
            className="absolute right-4 text-white/70 hover:text-white p-2"
            aria-label="Siguiente imagen"
          >
            <ChevronRight size={36} />
          </button>
          <p className="absolute bottom-4 text-white/50 text-sm">
            {activeIdx + 1} / {imagenes.length}
          </p>
        </div>
      )}
    </section>
  );
}